import React, { useState, useEffect, useRef } from 'react';
import './ProposalViewer.css';

const ImageViewerModal = ({ isOpen, onClose, images = [], hotel = null }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setCurrentIndex(0);
      setIsLoading(true);
      // Simulate loading
      setTimeout(() => setIsLoading(false), 300);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      
      switch (e.key) {
        case 'Escape':
          onClose();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          goToPrevious();
          break;
        case 'ArrowRight':
          e.preventDefault();
          goToNext();
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, currentIndex]);

  const goToPrevious = () => {
    setCurrentIndex(prev => 
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex(prev => 
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const handleOverlayClick = (e) => {
    if (e.target === modalRef.current) {
      onClose();
    }
  };

  if (!isOpen || images.length === 0) return null;

  const currentImage = images[currentIndex];

  return (
    <div 
      className="proposal-image-viewer-overlay" 
      onClick={handleOverlayClick}
      ref={modalRef}
    >
      <div className="proposal-image-viewer-modal">
        {/* Header */}
        <div className="proposal-image-viewer-header">
          <div className="proposal-hotel-info">
            <div className="proposal-hotel-title">
              {hotel?.name || 'Hotel Images'}
              {hotel?.rateTitle && ` / ${hotel.rateTitle}`}
            </div>
          </div>
          <button className="proposal-close-button" onClick={onClose}>
            ×
          </button>
        </div>

        {/* Main Image Container */}
        <div className="proposal-image-viewer-content">
          <div className="proposal-image-container">
            {isLoading ? (
              <div className="proposal-loading-spinner">
                <div className="proposal-spinner"></div>
                <p>Loading image...</p>
              </div>
            ) : (
              <img
                src={currentImage.url}
                alt={currentImage.name || `Image ${currentIndex + 1}`}
                className="proposal-main-image"
                onLoad={() => setIsLoading(false)}
                onError={() => setIsLoading(false)}
              />
            )}
          </div>

          {/* Navigation Arrows */}
          {images.length > 1 && (
            <>
              <button 
                className="proposal-nav-arrow proposal-nav-arrow-left"
                onClick={goToPrevious}
                title="Previous image (←)"
              >
                ‹
              </button>
              <button 
                className="proposal-nav-arrow proposal-nav-arrow-right"
                onClick={goToNext}
                title="Next image (→)"
              >
                ›
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageViewerModal;
